<div class="client-contracts__header">
  <p class="client-contracts__subtitle">
    Contratos Flat Fee e Gestão Ativa. Cada um nasce do modelo vigente do tipo; o texto das
    cláusulas é fixo e o contrato muda pelos valores e pelos dados do cadastro.
  </p>

  @if (canCreate()) {
    <app-button
      label="Gerar contrato"
      icon="pi pi-file-edit"
      type="button"
      (sendButtonClick)="openGenerateModal()" />
  }
</div>

<!-- Lista vazia: só o aviso de baixo (a tabela vazia repetiria "Nenhum item encontrado").
     `getOptionsFunction` com binding condicional: o `app-table` decide se mostra a coluna de ações
     pelo binding, não pelo que a função devolve (mesma régua da aba Contratos do parceiro).
     O `app-table` acha cada template pelo `field` da coluna: o nome do `appNamedTemplate` tem de ser
     igual ao `field` (com outro nome, a célula mostra o valor cru).
-->
@if (loading() || contracts().length) {
  <app-table
    [items]="contracts()"
    [columnDefinitions]="columnDefinitions"
    [loading]="loading()"
    [hasPagination]="contracts().length > 10"
    [inMemoryPagination]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 25, 50]"
    [getOptionsFunction]="hasRowActions() ? rowActions.bind(this) : undefined"
    (sendRowClick)="openEditor($event)">
    <ng-template appNamedTemplate="type" let-item>
      <span class="client-contracts__type">{{ typeLabel(item.type) }}</span>
    </ng-template>

    <ng-template appNamedTemplate="templateVersion" let-item>
      <span class="client-contracts__version">v{{ item.templateVersion }}</span>
    </ng-template>

    <ng-template appNamedTemplate="status" let-item>
      <span class="contract-status" [class.contract-status--finalized]="isFinalized(item.status)">
        {{ statusLabel(item.status) }}
      </span>
    </ng-template>

    <ng-template appNamedTemplate="outOfDefaultCount" let-item>
      @if (item.outOfDefaultCount > 0) {
        <span
          class="client-contracts__off-default"
          pTooltip="Valores diferentes do padrão: o envio vai pedir aprovação">
          {{ item.outOfDefaultCount }}
          {{ item.outOfDefaultCount === 1 ? 'valor' : 'valores' }}
        </span>
      } @else {
        <span class="client-contracts__default"><i class="pi pi-check"></i> No padrão</span>
      }
    </ng-template>
  </app-table>
}

@if (!loading() && !contracts().length) {
  <div class="client-contracts__empty">
    <i class="pi pi-file"></i>
    <p>
      Nenhum contrato gerado para esta empresa.
      @if (canCreate()) {
        Use <strong>Gerar contrato</strong> para criar um Flat Fee ou um Gestão Ativa a partir do
        modelo.
      }
    </p>
  </div>
}

<app-modal-generate-client-contract #generateModal (generated)="onGenerated($event)" />
